import { useState } from "react";
import { pdf } from "@react-pdf/renderer";
import { Capacitor } from "@capacitor/core";
import GlpRiportPdf from "../components/GlpRiportPdf";

interface Entry {
  // A D2 döntés óta hiányozhat (dózis-only bejegyzés) — `null` a drótról.
  weight?: number | null;
  dose?: number;
  date?: string;
  mellekhat?: Record<string, number>;
  createdAt?: { seconds: number };
  glucose?: number | null;
}

interface Profil {
  gyogyszer?: string;
  kezdoSuly?: string;
  celSuly?: string;
  terapiaKezdete?: string;
  glucoseEnabled?: boolean;
}

export function usePdfRiport() {
  const [generating, setGenerating] = useState(false);

  const generate = async (entries: Entry[], profil: Profil, userEmail: string) => {
    setGenerating(true);
    try {
      const blob = await pdf(
        <GlpRiportPdf entries={entries} profil={profil} userEmail={userEmail} />
      ).toBlob();
      const filename = `glp-riport-${new Date().toISOString().split("T")[0]}.pdf`;

      if (Capacitor.isNativePlatform()) {
        const { Filesystem } = await import("@capacitor/filesystem");
        const { Share } = await import("@capacitor/share");
        const { Directory } = await import("@capacitor/filesystem");

        const reader = new FileReader();
        const base64 = await new Promise<string>((resolve, reject) => {
          reader.onload = () => {
            const result = reader.result as string;
            resolve(result.split(",")[1]);
          };
          reader.onerror = reject;
          reader.readAsDataURL(blob);
        });

        const { uri } = await Filesystem.writeFile({
          path: filename,
          data: base64,
          directory: Directory.Cache,
        });

        await Share.share({
          title: "GLP Napló – terápia riport",
          text: "Terápia összefoglaló PDF",
          url: uri,
          dialogTitle: "Riport megosztása",
        });
      } else {
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = filename;
        a.click();
        URL.revokeObjectURL(url);
      }
    } finally {
      setGenerating(false);
    }
  };

  return { generate, generating };
}
